import { createApp } from 'vue';

import OfferFlats from './OfferFlats/OfferFlats.vue';

const app = createApp(OfferFlats);

app.mount('#offer-flats');